import {Button, Col, message, Row} from 'antd'
import React, {useEffect, useState} from 'react'
import {useRevalidator, useRouteLoaderData, useSubmit} from 'react-router-dom'
import {Project, TypedElement} from '../../entities/project'
import {EditorCreatePlot, PlotShapeType} from './editors/editorCreatePlot/EditorCreatePlot'
import {CanvasToolManager} from './toolLayers/CanvasToolManager'
import {ToolType} from './toolLayers/CanvasToolManager'
import {instance as projectService} from '../../services/ProjectsService'
import './editors/EditorCreateElements.less'
import {useIntl} from 'react-intl'
import {BulbOutlined} from '@ant-design/icons'

export function CanvasEditorPlot() {
  const {project} = useRouteLoaderData('project') as {project: Project}

  const [currentElementIndex, setCurrentElementIndex] = useState<number | null>(-1)
  const [currentPlotShape, setPlotShape] = useState(
    project.plotShape
      ? ({
          ...project.plotShape,
          type: 'plot',
        } as TypedElement)
      : null
  )
  const [plotShapeType, setPlotShapeType] = useState<PlotShapeType>(
    currentPlotShape?.shapeType as any
  )
  const [tool, setTool] = useState<ToolType>(null)

  const [messageApi, contextHolder] = message.useMessage()

  const [transformerProps, setTransformerProps] = useState<any>(null)

  const [isUnsaved, setIsUnsaved] = useState<boolean>(false)

  useEffect(() => {
    if (!project.plotShape && !currentPlotShape) {
      setIsUnsaved(false)
    } else if (project.plotShape && !currentPlotShape) {
      setIsUnsaved(true)
    } else {
      setIsUnsaved(
        project.plotShape
          ? JSON.stringify(project.plotShape.props) !== JSON.stringify(currentPlotShape.props)
          : true
      )
    }
  }, [currentPlotShape])

  const intl = useIntl()
  const revalidator = useRevalidator()

  return (
    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'stretch', padding: '10px'}}>
      {contextHolder}

      <div className="editor-create-elements">
        <EditorCreatePlot
          plot={currentPlotShape}
          plotShapeType={plotShapeType}
          onPlotShapeTypeChanged={setPlotShapeType}
          onPlotUpdated={setPlotShape}
          tool={tool}
          onToolSelected={(tool) => {
            if (currentPlotShape) {
              if (confirm(intl.formatMessage({id: 'plotWillBeDeleted'}))) {
                setPlotShape(null)
                setTool(tool)
              }
            } else {
              setTool(tool)
            }
          }}
          transformerProps={transformerProps}
          onTransformerPropsChange={setTransformerProps}
        ></EditorCreatePlot>
        {isUnsaved ? (
          <div className="editor-fields-warning">
            {intl.formatMessage({id: 'projectChangedSaveBeforeProceedingToTheNextStep'})}
          </div>
        ) : null}
        <Button
          type="primary"
          style={{margin: '20px 0', width: '100%'}}
          onClick={async () => {
            const result = await projectService.editProject({
              ...project,
              plotShape: currentPlotShape,
            })
            if (result.success === false) {
              messageApi.open({
                type: 'error',
                content: result.error?.message,
              })
            } else {
              setIsUnsaved(false)
            }
          }}
        >
          {intl.formatMessage({id: 'save'})}
        </Button>
        <div style={{color: 'green', display: 'flex', alignItems: 'flex-start', minWidth: '320px'}}>
          <BulbOutlined style={{padding: '5px 10px 0px 0px'}} />

          <span>{intl.formatMessage({id: 'advicePlotMapFirst'})}</span>
        </div>
      </div>

      <div style={{padding: '15px', width: '100%'}}>
        <div style={{boxShadow: '15px 15px #fa8c16', height: '100%'}}>
          <CanvasToolManager
            canvasEditorProps={{
              projectId: project?.id,
              plotShape: currentPlotShape,
              elements: project?.elements,
              selectable: false,
              plotShapeEditable: true,
              onPlotShapeChanged: (newShape) => {
                setPlotShape({...newShape, type: 'plot'})
              },
              onElementChanged: (updatedElement: TypedElement) => {
                setPlotShape(updatedElement)
              },
              selectedElementId: currentElementIndex,
              setSelectedElementId: setCurrentElementIndex,
              hasMap: Boolean(project?.location?.map),
              transformerLayerProps: transformerProps,
            }}
            tool={tool}
            onElementDrawn={(shape) => {
              setPlotShape({
                shapeType: shape.type,
                props: shape.props,
                elementId: 0,
                name: 'plot',
                type: 'plot',
              })
              setCurrentElementIndex(-1)
              setTool(null)
            }}
          />
        </div>
      </div>
    </div>
  )
}
